import React, { useState } from 'react';
//import { useTable } from 'react-table';
import moment from 'moment';
import { Table, Badge, Text, Checkbox, Button } from '@mantine/core';
//import { AppLoader } from '../../../../components/common/loader';
import { Styles } from '../../../../components/tables/skutable/production-site/styles';
import { ActionModal } from '../actionModal';
import { ProductionLog } from '../productionSiteLogModal';
import { liquidBomChanges, liquidTypes, materialTypes } from '../../../../constants';

const MaterialsContractTableVEAM = ({ materialDataList, type, save, readOnly }) => {
  const [actionModal, setActionModal] = useState({ open: false, id: '' });
  const [logModal, setLogModal] = useState({ open: false, id: '' });
  const [imp_id, setImp_id] = useState(0);
  //const [htmlData, setHtmlData] = useState('');
  const [status, setStatus] = useState('');
  const [checked, setChecked] = useState(false);

  const Action = (item) => {
    return item.status === 'In Progress' || item.status === 'Not Started' ? (
      <Checkbox
        disabled={(item.status === 'In Progress' ? false : true) || readOnly}
        onChange={(event) => {
          setChecked(event.target.checked);
          setStatus(item.id);
          setActionModal({ open: true, id: item.id });
        }}
        label='Confirm and Close'
      />
    ) : item.manually_closed && item.status === 'Closed' ? (
      <Text>Manually Closed</Text>
    ) : (
      <Text>Automatic Closure</Text>
    );
  };

  const getLogs = (imp_id) => {
    setLogModal({ open: true, id: imp_id });
    setImp_id(imp_id);
  };

  const Logs = (id) => {
    return (
      <Button 
      onClick={() => getLogs(id)} 
      style={{ background: 'black', color:'white' }}>
        View Logs
      </Button>
    );
  };

  const filteredData = (data) => {
    return data.map((item) => {
      let Code = 'N/A',
        new_num = 'N/A',
        new_name = 'N/A',
        type_of_change = 'N/A',
        changeovertype = 'N/A',
        changeoverdate = 'N/A',
        //comment = 'N/A',
        Desc;

      if (item.selection_type === 'materials') {
        if (
          item.material_type === materialTypes.existing ||
          item.material_type === materialTypes.remove
        ) {
          Code = item.material_code_or ? item.material_code_or : 'N/A';
          new_num = item.int_rfs_material_number ? item.int_rfs_material_number : 'N/A';

          Desc = item.material_description_or;
          new_name = item.pack_mat_material_text ? item.pack_mat_material_text : 'N/A';
        } else if (item.material_type === materialTypes.new) {
          Code = item.material_code_or ? item.material_code_or : 'N/A';
          new_num = item.new_material_code ? item.new_material_code : 'N/A';

          Desc = item.material_description_or;
          new_name = item.new_material_description_intrfsml
            ? item.new_material_description_intrfsml
            : 'N/A';
        }

        type_of_change = item.material_type ? item.material_type : 'N/A';
        changeovertype = item.material_changeover_type ? item.material_changeover_type : 'N/a';
        changeoverdate = item.material_changeover_date ? item.material_changeover_date : 'N/A';
        //comment = item.material_comment ? item.material_comment : 'N/A';
      }

      if (item.selection_type === 'liquids') {
        if ([liquidTypes.add, liquidTypes.new].includes(item.liquid_type) && !item.liquid_number) {
          Code = item.liquid_code ? item.liquid_code : 'N/A';
          new_num = item.new_material_code ? item.new_material_code : 'N/A';

          Desc = item.liquid_description;
          new_name = item.new_material_description_intrfsml
            ? item.new_material_description_intrfsml
            : 'N/A';
        } else {
          Code = item.liquid_code ? item.liquid_code : 'N/A';
          new_num = Code;

          Desc = item.liquid_description;
          new_name = Desc;
        }

        type_of_change = item.liquid_type ? item.liquid_type : 'N/A';
        changeovertype = item.liquid_changeover_type ? item.liquid_changeover_type : 'N/a';
        changeoverdate = item.liquid_changeover_date ? item.liquid_changeover_date : 'N/A';
        //comment = item.liquid_comment ? item.liquid_comment : 'N/A';
      }

      return {
        'Pack Mat Code': new_num ? new_num : 'N/A',
        'Pack Mat Description': new_name ? new_name : 'N/A',
        Plant: item.plant,
        Status: (
          <Badge
            color={
              item.status === 'In Progress' ? 'yellow' : item.status === 'Closed' ? 'green' : 'gray'
            }
            size='lg'
          >
            {' '}
            {item.status}{' '}
          </Badge>
        ),
        Action: Action(item),
        Logs: Logs(item.id),
        'SLA Date': moment(item.sla_date).format('YYYY-MM-DD'),
        'Step Finished': item.finished_date
          ? moment(item.finished_date).format('YYYY-MM-DD')
          : item.status,
        scope_selection_code: item.material_code + ' - ' + item.material_description,
        scope_id: item.scope_id,
      };
    });
  };

  const filteredDataRes = filteredData(materialDataList);

  const HtmlRenderedData = ({ type }) => {
    const heads = (
      <thead>
        <tr id='header-row'>
          <th>{type === 'Materials' ? 'Pack Mat Code' : 'Liquid Code'}</th>
          <th>{type === 'Materials' ? 'Pack Mat Description' : 'Liquid Description'}</th>
          <th>Plant</th>
          <th>Status</th>
          <th>Action</th>
          <th>Logs</th>
          <th>Step Deadline</th>
          <th>Step Finished</th>
        </tr>
      </thead>
    );

    const Materials = () => {
      const rowsData = filteredDataRes.map((item, index) => (
        <tr key={index}>
          {Object.values(item).map((it, i) => {
            return (
              i < 8 && (
                <td key={i} style={{ padding: '0.8rem !important' }}>
                  {it}
                </td>
              )
            );
          })}
        </tr>
      ));

      return (
        <Table>
          {heads}
          <tbody>{rowsData}</tbody>
        </Table>
      );
    };

    return <Materials />;
  };

  return (
    <Styles>
      <div style={{ overflow: 'auto' }}>
        <HtmlRenderedData type={type} />
      </div>

      {actionModal && (
        <ActionModal
          actionModal={actionModal}
          setActionModal={setActionModal}
          save={save}
          status_id={status}
        />
      )}

      {logModal && (
        <ProductionLog
          logModal={logModal}
          setLogModal={setLogModal}
          id={imp_id}
          type='Material Contracts'
        />
      )}
    </Styles>
  );
};

export default MaterialsContractTableVEAM;
